import React, { useState } from 'react';
import { treatSpaceOrEnterAsClick } from '~/helpers/events';
function Option({ item, name, required, selectedValue, onChange }) {
    return (React.createElement("div", { className: "radio-control-group" },
        React.createElement("label", { tabIndex: 0, onKeyDown: treatSpaceOrEnterAsClick },
            React.createElement("input", { type: "radio", name: name, value: item.value, checked: item.value === selectedValue, required: required, onChange: onChange }),
            item.label)));
}
export default function FormRadioGroup({ longLabel, name, options, required }) {
    var _a;
    const ref = React.useRef(null);
    const [validationMessage, setValidationMessage] = useState('');
    const checkedValue = (_a = options.find((opt) => opt.checked)) === null || _a === void 0 ? void 0 : _a.value;
    const [selectedValue, setSelectedValue] = useState(checkedValue);
    const validate = React.useCallback(() => {
        var _a;
        const invalid = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector(':invalid');
        setValidationMessage(invalid ? invalid.validationMessage : '');
    }, []);
    const onChange = React.useCallback(({ target: { value } }) => {
        setSelectedValue(value);
        validate();
    }, [validate]);
    const passThruProps = React.useMemo(() => ({ name, required, selectedValue, onChange }), [name, required, selectedValue, onChange]);
    React.useEffect(validate, [validate]);
    return (React.createElement("div", { className: "form-radiogroup" },
        longLabel && (React.createElement("label", { className: "field-long-label" }, longLabel)),
        React.createElement("div", { ref: ref }, options.map((item) => (React.createElement(Option, Object.assign({ item: item }, passThruProps, { key: item.value }))))),
        React.createElement("div", { className: "invalid-message" }, validationMessage)));
}
